import { AuthorByline } from "@/components/site/AuthorByline";
import { personRef } from "@/content/author";
import { socialImageMeta } from "@/lib/social-sharing";
import shareCover from "@/assets/book-cover-share.jpg.asset.json";
import { createFileRoute } from "@tanstack/react-router";
import coverAsset from "@/assets/book-cover-space.jpg";
import { hreflangLinks } from "@/lib/seo";
import { PageIntro, PageSection, Prose, MoreLink } from "@/components/site/page";

const CANONICAL = "https://akillisurdurulebilirlik.com/kitaplar/hayati-yasanir-kilan-bosluktur";

const retailers = [
  {
    name: "Destek Dükkân",
    url: "https://destekdukkan.com/magaza/urun/hayati-yasanir-kilan-bosluktur",
    note: "Yayıncı resmi mağazası",
    primary: true,
  },
  {
    name: "Amazon",
    url: "https://www.amazon.com.tr/Hayat%C4%B1-Ya%C5%9Fan%C4%B1r-K%C4%B1lan-Bo%C5%9Fluktur-%C3%96zta%C5%9Fk%C4%B1n/dp/6258843204/ref=sr_1_5?dib=eyJ2IjoiMSJ9.UDSejTNDq6GsfMtGqZAFVQKADG_pSAd_fGzgY-PoKJbGjHj071QN20LucGBJIEps.m0Owy-iWWeZ8ZmrhDOnjbXz96MD4UiieaY4y86HWAMU&dib_tag=se&qid=1790073793&refinements=p_27%3AArda+%C3%96zta%C5%9Fk%C4%B1n&s=books&sr=1-5",
    note: "Online satış",
  },
  {
    name: "Kitapyurdu",
    url: "https://www.kitapyurdu.com/kitap/hayati-yasanir-kilan-bosluktur/767368.html?srsltid=AU7gw4W5FOTDhy--SG8ZmqKtj5pbEgIqywS_9eebKU_X9rgxIUfYcKZv",
    note: "Online satış",
  },
  {
    name: "Pandora",
    url: "https://www.pandora.com.tr/kitap/hayati-yasanir-kilan-bosluktur/991154",
    note: "Online satış",
  },
  {
    name: "D&R",
    url: "https://www.dr.com.tr/kitap/hayati-yasanir-kilani-bosluktur/arda-oztaskin/edebiyat/roman/turk-romani/urunno=0002243889001?srsltid=AU7gw4VVHHtDO-kLPiUrvbU1kCyQj7i5CJYG-SeZZ284iLzEsAoWU_6H",
    note: "Online satış",
  },
];

const press: { outlet: string; title: string; url: string }[] = [
  {
    outlet: "MediaCat",
    title: "Arda Öztaşkın'ın yeni kitabı okuyucu ile buluştu",
    url: "https://mediacat.com/arda-oztaskinin-yeni-kitabi-okuyucu-ile-bulustu/",
  },
  {
    outlet: "Marketing Türkiye",
    title: "Arda Öztaşkın'ın yeni kitabı verimlilik çağında \"boşluğa\" yer açıyor",
    url: "https://www.marketingturkiye.com.tr/haberler/arda-oztaskinin-yeni-kitabi-verimlilik-caginda-bosluga-yer-aciyor/",
  },
  {
    outlet: "BrandMap",
    title: "Arda Öztaşkın'ın yeni kitabı \"Hayatı Yaşanır Kılan, Boşluktur\" raflardaki yerini aldı",
    url: "https://www.brandmap.com.tr/post/arda-%C3%B6zta%C5%9Fk%C4%B1n-%C4%B1n-yeni-kitab%C4%B1-hayat%C4%B1-ya%C5%9Fan%C4%B1r-k%C4%B1lan-bo%C5%9Fluktur-raflardaki-yerini-ald%C4%B1",
  },
  {
    outlet: "Campaign Türkiye",
    title: "Arda Öztaşkın'ın yeni kitabı raflarda: \"Hayatı Yaşanır Kılan, Boşluktur\"",
    url: "https://www.campaigntr.com/haberler/arda-oztaskinin-yeni-kitabi-raflarda-hayati-yasanir-kilan-bosluktur/",
  },
  {
    outlet: "Ad Just Brand",
    title: "Arda Öztaşkın yeni kitabında verimlilik kültürünü sorguluyor",
    url: "https://www.adjustbrand.com/guncel/arda-oztaskin-yeni-kitabinda-verimlilik-kulturunu-sorguluyor/",
  },
];

const toc = [
  {
    part: "Başlarken",
    chapters: [],
  },
  {
    part: "Bölüm 1 — Verimlilik, nasıl dünya görüşüne dönüştü?",
    chapters: [
      "Her şey kıtlıkla başladı",
      "İnsan hayatının amacı",
      "Niçin'den nasıl'a",
      "Hesaplanan dünya",
      "Kronometrenin ahlâkı",
      "Verimlilik ve iktidar",
      "Toplum piyasası",
      "Teknoloji döngüsü",
      "Fabrika insan",
    ],
  },
  {
    part: "Bölüm 2 — Bolluğun krizleri ve ölçünün tiranlığı",
    chapters: [
      "Başarıdan doğan kriz",
      "Ölçünün sınırı",
      "Ölçülenin imparatorluğu",
      "Göstergenin emri",
      "Sayının ahlâkı",
      "Harita, arazinin önüne geçtiğinde",
      "Göstergenin isyanı",
      "Gerçekliğin geri kalanı",
    ],
  },
  {
    part: "Bölüm 3 — Aynı ateş, farklı yerlerden duman",
    chapters: [
      "Merceği dumana tutmak",
      "Enerji",
      "İklim",
      "Yapay zekâ",
      "Ekonomi",
      "Çalışma hayatı",
      "Hakikatin çöküşü",
      "İnsan",
    ],
  },
  {
    part: "Bölüm 4 — Telosu geri çağırmak",
    chapters: [
      "Ateşin adı",
      "Derinde yanan alev",
      "Ölçülemeyenin savunması",
      "İnsanın kendisini sürdürebilmek",
      "Karar mimarisi",
      "Bilinçli verimsizlik",
      "Sahi, ne için?",
    ],
  },
  {
    part: "Kapanış",
    chapters: ["Akılda ne kalsın", "Kaynakça"],
  },
];

const paragraphs = [
  <>Kitap adını Lao Tzu’ya atfedilen bir düşünceden alıyor: “Bir odayı yaşanır kılan, duvarları değil, içindeki boşluktur.” Bir hayatı yaşanır kılan da her anının doldurulması, ölçülmesi ve en verimli hâle getirilmesi değil; nefes alacak yer bırakılmasıdır.</>,
  <>Bugün nereye baksak başka bir alarm görüyoruz. İklim krizi derinleşiyor. Yapay zekâ işlerimizle birlikte kararlarımıza ve muhakememize de ortak oluyor. Toplumlar kutuplaşıyor, ortak gerçeklik duygusu aşınıyor. İnsanlık tarihinin en bağlantılı çağında yalnızlık büyüyor. Kurumlardan tedarik zincirlerine, demokrasilerden kendi sinir sistemlerimize kadar her şey daha kırılgan görünüyor.</>,
  <>Sanki aynı anda on ayrı yangın çıkmış ve biz bir kova suyla birinden ötekine koşuyoruz. Peki ya bunlar ayrı yangınlar değil, aynı büyük ateşin farklı yerlerden yükselen dumanlarıysa?</>,
  <>Kitabın çıkış noktası bu soru. Bana göre, birbirinden kopuk görünen birçok sorunun ardında ortak bir zihniyet var. Ve o zihniyet, çağımızın en makul, en az itiraz edilen kavramlarından birinin etrafında şekilleniyor: <strong>Verimlilik.</strong></>,
  <>Verimli kılmak için önce ölçüyoruz. Sonra ölçebildiklerimizi yönetiyor, ödüllendiriyor, büyütüyoruz. Peki ölçemediklerimize ne oluyor? Güvene, muhakemeye, anlamaya, birlikte geçirilen zamana? Kârlılık artarken güven azalıyor mu? Hız kazanırken anlam kayboluyor mu? Verimlilik yükselirken insan eksiliyor mu?</>,
  <>Bu kitap, verimliliğin hayatımızdaki yerini sorguluyor. Her şeyi aynı ölçüye vurmanın bedelini soruyor. Çünkü çocuğunuzla geçirdiğiniz zamanın, bir dostluğun, vicdanınızın ya da bir ağacın gölgesinin performans tablosunda karşılığı olmak zorunda değil.</>,
  <>Her şeyin skora ve çıktıya bağlandığı bir çağda, bazı alanları ölçünün dışında tutmak bir medeniyet tercihidir. Belki de önümüzdeki dönemin en önemli becerisi, neyi daha verimli yapacağımızı bulmak kadar, neyi verimlilik hesabından koruyacağımızı bilmek olacak.</>,
];

export const Route = createFileRoute("/kitaplar/hayati-yasanir-kilan-bosluktur")({
  head: () => ({
    meta: [
      { title: "Hayatı Yaşanır Kılan, Boşluktur — Arda Öztaşkın" },
      {
        name: "description",
        content: "Arda Öztaşkın'ın yeni kitabı: verimlilik, ölçü ve insan kalmanın bedeli üzerine. Kitap hakkında, içindekiler ve satış bağlantıları.",
      },
      { property: "og:title", content: "Hayatı Yaşanır Kılan, Boşluktur — Arda Öztaşkın" },
      {
        property: "og:description",
        content: "Her şeyi verimlilik hesabına bağlayan çağda, ölçünün dışında kalması gerekenleri savunan yeni kitap.",
      },
      { property: "og:type", content: "book" },
      { property: "og:url", content: CANONICAL },
      { name: "twitter:title", content: "Hayatı Yaşanır Kılan, Boşluktur — Arda Öztaşkın" },
      { name: "twitter:description", content: "Her şeyi verimlilik hesabına bağlayan çağda, ölçünün dışında kalması gerekenleri savunan yeni kitap." },
      ...socialImageMeta(`https://akillisurdurulebilirlik.com${shareCover.url}`),
    ],
    links: [
      { rel: "canonical", href: CANONICAL },
      ...hreflangLinks("/kitaplar/hayati-yasanir-kilan-bosluktur"),
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "Book",
              name: "Hayatı Yaşanır Kılan, Boşluktur",
              description: "Verimlilik, ölçü ve insan kalmanın bedeli üzerine bir kitap.",
              inLanguage: "tr",
              isbn: "9786258843200",
              datePublished: "2026-09",
              author: personRef(),
              publisher: { "@type": "Organization", name: "Destek Yayınları" },
              url: CANONICAL,
              bookFormat: "https://schema.org/Paperback",
              potentialAction: {
                "@type": "ReadAction",
                target: retailers.map((retailer) => retailer.url),
              },
            },
            {
              "@type": "BreadcrumbList",
              itemListElement: [
                { "@type": "ListItem", position: 1, name: "Ana Sayfa", item: "https://akillisurdurulebilirlik.com/" },
                { "@type": "ListItem", position: 2, name: "Kitaplar", item: "https://akillisurdurulebilirlik.com/kitaplar" },
                { "@type": "ListItem", position: 3, name: "Hayatı Yaşanır Kılan, Boşluktur", item: CANONICAL },
              ],
            },
          ],
        }),
      },
    ],
  }),
  component: NewBookPage,
});

function Cover() {
  return (
    <img
      src={coverAsset}
      alt="Hayatı Yaşanır Kılan, Boşluktur — Arda Öztaşkın kitap kapağı"
      width={1122}
      height={1402}
      fetchPriority="high"
      decoding="async"
      className="aspect-[2/3] w-full max-w-[200px] object-cover shadow-sm lg:max-w-[280px]"
    />
  );
}

function NewBookPage() {
  return (
    <div>
      <PageIntro
        crumbs={[{ label: "Kitaplar", to: "/kitaplar" }, { label: "Hayatı Yaşanır Kılan, Boşluktur" }]}
        kicker="Yeni kitap · 2026"
        dot="bg-theme-meaning"
        title={<>Hayatı Yaşanır Kılan, <em className="italic">Boşluktur</em></>}
        lede="İnsanın, yaşamın ve anlamın son sığınağı."
        aside={<Cover />}
      >
        <AuthorByline />
        <div className="mt-5 lg:hidden"><Cover /></div>
      </PageIntro>

      <PageSection title="Kitap hakkında">
        <Prose>
          {paragraphs.map((paragraph, index) => <p key={index}>{paragraph}</p>)}
        </Prose>
      </PageSection>

      <PageSection title="İçindekiler">
        <div className="grid gap-7 sm:grid-cols-2">
          {toc.map((part) => (
            <div key={part.part} className="space-y-2">
              <h3 className="font-serif text-base text-ink/85">{part.part}</h3>
              {part.chapters.length > 0 && (
                <ul className="list-disc space-y-1.5 pl-5 text-sm leading-relaxed text-ink/75 marker:text-ink/30">
                  {part.chapters.map((chapter) => <li key={chapter}>{chapter}</li>)}
                </ul>
              )}
            </div>
          ))}
        </div>
      </PageSection>

      <PageSection title="Basında">
        <ul className="space-y-4">
          {press.map((p) => (
            <li key={p.url}>
              <MoreLink href={p.url}>{p.title}</MoreLink>
              <p className="mt-1 text-xs text-ink/60">{p.outlet}</p>
            </li>
          ))}
        </ul>
      </PageSection>

      <PageSection title="Satın al">
        <div className="flex flex-wrap gap-3">
          {retailers.map((retailer) => (
            <a
              key={retailer.name}
              href={retailer.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`inline-flex min-h-11 items-center gap-2 rounded-full border px-4 text-sm ${retailer.primary ? "border-ink bg-ink text-paper" : "border-ink/20 text-ink/80 hover:border-ink"}`}
            >
              {retailer.name} <span className="text-xs opacity-70">{retailer.note}</span>
            </a>
          ))}
        </div>
      </PageSection>

      <PageSection>
        <p className="text-sm text-ink/70">Destek Yayınları · Eylül 2026</p>
        <div className="mt-3"><MoreLink to="/kitaplar">Tüm kitaplara dön</MoreLink></div>
      </PageSection>
    </div>
  );
}
